import { defineComponent as _defineComponent } from 'vue';
import { vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value"];
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Checkbox',
    props: {
        checked: { type: Boolean },
        value: {}
    },
    emits: ['update:checked'],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const proxyChecked = computed({
            get() {
                return props.checked;
            },
            set(val) {
                emit('update:checked', val);
            },
        });
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                type: "checkbox",
                value: __props.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((proxyChecked).value = $event)),
                class: "rounded border-gray-300 text-indigo-600 shadow-sm focus:ring-indigo-500"
            }, null, 8, _hoisted_1)), [
                [_vModelCheckbox, proxyChecked.value]
            ]);
        };
    }
});
